module.exports = __webpack_public_path__ + "img/vko1.999b1b4e.jpg";